import { render } from "./PartnersList.vue?vue&type=template&id=52b9ed34"
import script from "./PartnersList.vue?vue&type=script&lang=js"
export * from "./PartnersList.vue?vue&type=script&lang=js"

import exportComponent from "/home/le01s/projects/amlogger/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__